import {connect} from 'react-redux'
import {Link, withRouter} from 'react-router-dom'

import PageLayout from '../../containers/Layout/PageLayout.jsx'

import submitUser from '../../containers/Freelance/submit.js'
import {generate} from '../../routes.js'

const mustHaveAcceptedCGU = function (Component) {
  let mustHaveAcceptedCGUComponent = (props) => {
    const {currentUser, loading, ...rest} = props

    const acceptCGU = async () => {
      try {
        await submitUser({
          user: currentUser.id,
          cgu_accepted: true
        })
      } catch (e) {
        console.warn(e)
      }
    }

    if (loading) {
      return null
    }

    if (currentUser && !currentUser.cgu_accepted) {
      return (
        <PageLayout>
          <h2 className="text-center">
            Nos CGU ont été mises à jour
          </h2>
          <p className="text-center mb-5">
            Vous devez accepter les <Link to={generate({name: 'cgu'})} target="_blank" rel="noopener noreferrer">
            conditions générales d'utilisation</Link> pour pouvoir accéder à cette page.
          </p>
          <p className="text-center">
            <button onClick={acceptCGU} type="button" className="btn btn-primary">
              Accepter les CGU
            </button>
          </p>
        </PageLayout>
      )
    }

    return <Component currentUser={currentUser} {...rest}/>
  }

  mustHaveAcceptedCGUComponent = connect(
    state => ({
      currentUser: state.currentUser.user,
      loading: state.currentUser.loading
    })
  )(mustHaveAcceptedCGUComponent)

  return withRouter(mustHaveAcceptedCGUComponent)
}

export default mustHaveAcceptedCGU